import {toast} from "vue3-toastify";

export const makeErrorToast = (title: string) => {
    toast(title, {
        type: "error",
        autoClose: 5000,
    });
};

export const makeSuccessToast = (title: string) => {
    toast(title, {
        type: "success",
        autoClose: 5000,
    });
};
